var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":_vm.setTheme}},[_c('router-view',{attrs:{"name":"navbar"}}),_c('v-main',[_c('router-view',{}),_c('router-view',{attrs:{"name":"footer"}}),_c('GlobalSnackbar')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }